module.exports = __webpack_public_path__ + "img/PlaceHolderSquare.feeb3d0a.png";